import { Coupon } from '@/model/schemas';

import { ApiResponse } from '../http/BaseHttpClient';
import AbstractService from './AbstractService';

export class CouponService extends AbstractService {
  async getCoupons(params?: Record<string, any>): Promise<Coupon[]> {
    const response = await this.get<Coupon[]>(this.endpoint('coupons'), params);
    const data = (response as any)?.data ?? response;

    this.logger.debug({ message: 'CouponService:getCoupons', count: (data as any)?.length, params });

    if ((data as any)?.error) {
      throw new Error((data as any).error?.message || 'Failed to fetch coupons');
    }

    return data as Coupon[];
  }

  async getCouponByCode(code: string, params?: Record<string, any>): Promise<Coupon> {
    const response = await this.get<Coupon>(this.endpoint('couponByCode', { code }), params);
    const data = (response as any)?.data ?? response;

    if ((data as any)?.error) {
      throw new Error((data as any).error?.message || 'Failed to fetch coupon');
    }

    return data as Coupon;
  }

  async getCoupon(code: string, params?: Record<string, any>): Promise<Coupon> {
    return this.getCouponByCode(code, params);
  }

  async validateCoupon(code: string, params?: Record<string, any>): Promise<{ valid: boolean; message?: string; coupon?: Coupon }> {
    const response = await this.get<{ valid: boolean; message?: string; coupon?: Coupon }>(this.endpoint('couponValidate', { code }), params);
    const data = (response as any)?.data ?? response;

    if ((data as any)?.error) {
      throw new Error((data as any).error?.message || 'Failed to validate coupon');
    }

    return data as { valid: boolean; message?: string; coupon?: Coupon };
  }
}

export const couponService = new CouponService();

export default CouponService;
